module.exports = __webpack_public_path__ + "img/unit2-architectural.a18fa311.svg";